

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PiutangPdf from "./pdf";
import { Helmet } from "react-helmet";
import LayoutDashboard from "../../../../components/layouts/layout_dashboard";
import CustomHeader from "../../../../components/customs/header";
import BtnBack from "../../../../components/buttons/btn_back";
import { showDebiturCreditur } from "../../../../services/user_management/debitur_creditur_service";
import { getPiutang, showPiutang } from "../../../../services/finance/piutang_service";

const PiutangPrint = () => {
    const [accessToken, setAccessToken] = useState("")
    const [userRole, setUserRole] = useState("")
    const navigate = useNavigate()
    const { id } = useParams()

    const [loading, setLoading] = useState(false)
    const [refresh, setRefresh] = useState(false)

    const [openPiutangCreate, setOpenPiutangCreate] = useState(false)

    const [debit, setDebit] = useState(0)
    const [credit, setCredit] = useState(0)
    const [dataCreditur, setDataCreditur] = useState(null)
    const [data, setData] = useState([])
    const fetchData = async (accessToken) => {
        setLoading(true)
        try {
            const response = await showPiutang(accessToken, id)
            if (response.status === 200) {
                setDebit(response.data.debit)
                setCredit(response.data.credit)
                setData(response.data.data);
                setDataCreditur(response.data.creditur)
            }
        } catch (error) {
            console.log("__")
        }
        setLoading(false)
    }

    useEffect(() => {
        const getAccessToken = localStorage.getItem('access_token-terra_app')
        const getUserRole = localStorage.getItem('user_role-terra_app')

        setAccessToken(getAccessToken)
        fetchData(getAccessToken)
    }, [])

    const totalDebit = data.reduce((total, item) => {
        return item?.category?.name === 'piutang dibayar' ? total + item.nominal : total; // Hitung total debit
    }, 0);

    const totalKredit = data.reduce((total, item) => {
        return item?.category?.name === 'piutang' ? total + item.nominal : total; // Hitung total debit
    }, 0);
    
    return (
        <>
            <Helmet>
                <title>Piutang Pdf</title>
            </Helmet>
            <LayoutDashboard>
                <CustomHeader>
                    <BtnBack />
                    <p className="text-center uppercase">Piutang Print Pdf</p>
                </CustomHeader>
                <div className="w-full h-full -mt-16 pt-16">
                    <PiutangPdf
                        dataCreditur={dataCreditur} dataTransaction={data}
                        totalPiutang={totalKredit} totalPiutangDibayar={totalDebit}
                        sisaPiutang={totalKredit - totalDebit}
                    />
                </div>
            </LayoutDashboard>
        </>
    )
}

export default PiutangPrint